import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
declare var require: any;
import { Router, Event, NavigationStart, NavigationEnd } from '@angular/router';
import {Title,Meta} from '@angular/platform-browser';
import { title } from 'process';
import { filter } from 'rxjs/operators';
import { A } from 'node_modules_0101/@angular/cdk/keycodes';
declare let gtag: Function;
declare let ga: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  //title = 'hiworkweb';

  constructor(private router: Router, 
      private titleService: Title,
      private meta: Meta,
    protected localIndexDBStorage: LocalStorage) 
    {           
  
      router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                  debugger;
                  //alert('1');
                    ga('set', 'page', event.urlAfterRedirects);
                    ga('send', 'pageview');
                  }
                  
      if (event instanceof NavigationStart) {
        // tslint:disable-next-line:max-line-length
        if ( ((event.url !== '/client/registration' && event.url !== '/en/client/registration')  && (event.url !== '/kr/client/registration' && event.url !== '/cn/client/registration') ) &&
        // tslint:disable-next-line:max-line-length
        ((event.url !== '/client/registration-preview' && event.url !== '/en/client/registration-preview') && (event.url !== '/kr/client/registration-preview' && event.url !== '/cn/client/registration-preview'))
        ) {
              localStorage.removeItem('company-form-data');
              localStorage.removeItem('company-form-Industry');
        }
        // tslint:disable-next-line:max-line-length
        if ( ((event.url !== '/client/edit' && event.url !== '/en/client/edit')  && (event.url !== '/kr/client/edit' && event.url !== '/cn/client/edit') ) &&
        // tslint:disable-next-line:max-line-length
        ((event.url !== '/client/edit-preview' && event.url !== '/en/client/edit-preview') && (event.url !== '/kr/client/edit-preview' && event.url !== '/cn/client/edit-preview'))
        ) {
              localStorage.removeItem('company-edit-form-data');
              localStorage.removeItem('company-edit-form-Industry');
        }
        // tslint:disable-next-line:max-line-length
        if ( (event.url !== '/client/job-posting' && event.url !== '/en/client/job-posting' ) && 
        // tslint:disable-next-line:max-line-length
        (event.url !== '/client/job-posting-preview' && event.url !== '/en/client/job-posting-preview')
        ) {
              localStorage.removeItem('total-data');
        }

        if ( (event.url !== '/client/banner-advertisement-plan' && event.url !== '/en/client/banner-advertisement-plan' )  &&
        (event.url !== '/client/banner-advertisement-upload' && event.url !== '/en/client/banner-advertisement-upload')
        ) {
              localStorage.removeItem('plan-info-object');
              localStorage.removeItem('tab');
        }

        if ( event.url !== '/client/labor-market' && event.url !== '/en/client/labor-market' ) {
              localStorage.removeItem('labor-section');
        }

        // tslint:disable-next-line:max-line-length
        if ( ((event.url !== '/client/voice-of-foreign-employee' && event.url !== '/en/client/voice-of-foreign-employee' )) &&
        // tslint:disable-next-line:max-line-length
        ((event.url !== '/client/voice-of-foreign-employee-preview' && event.url !== '/en/client/voice-of-foreign-employee-preview'))
        ) {
              this.localIndexDBStorage.removeItem('voice-of-foreign-employee').subscribe(() => {});
        }

        // tslint:disable-next-line:max-line-length
        if (
        // tslint:disable-next-line:max-line-length
        (event.url !== '/apply-job-preview' && event.url !== '/en/apply-job-preview') && (event.url !== '/kr/apply-job-preview' && event.url !== '/cn/apply-job-preview')
        ) {
              localStorage.removeItem('staff-application');
        }


        // tslint:disable-next-line:max-line-length
        if ( ( (event.url !== '/registration' && event.url !== '/en/registration' ) && (event.url !== '/kr/registration' && event.url !== '/cn/registration' ) ) &&
        // tslint:disable-next-line:max-line-length
        ( (event.url !== '/registration-preview' && event.url !== '/en/registration-preview') && (event.url !== '/kr/registration-preview' && event.url !== '/cn/registration-preview') )
        ) {
              localStorage.removeItem('staff-registration-data');
        }
        // tslint:disable-next-line:max-line-length
        if ( ( (event.url !== '/registration-basic-info' && event.url !== '/en/registration-basic-info' ) && (event.url !== '/kr/registration-basic-info' && event.url !== '/cn/registration-basic-info' ) ) &&
        // tslint:disable-next-line:max-line-length
        ((event.url !== '/registration-basic-info-preview' && event.url !== '/en/registration-basic-info-preview') && (event.url !== '/kr/registration-basic-info-preview' && event.url !== '/cn/registration-basic-info-preview') )
        ) {
              localStorage.removeItem('staff-basic-form');
        }

        // tslint:disable-next-line:max-line-length
        if ( ((event.url !== '/registration-education-history' && event.url !== '/en/registration-education-history' ) && (event.url !== '/kr/registration-education-history' && event.url !== '/cn/registration-education-history' ) ) &&
        // tslint:disable-next-line:max-line-length
        ((event.url !== '/registration-education-history-preview' && event.url !== '/en/registration-education-history-preview') && (event.url !== '/kr/registration-education-history-preview' && event.url !== '/cn/registration-education-history-preview') )
        ) {
              localStorage.removeItem('education-history');
        }
        // tslint:disable-next-line:max-line-length
        if ( ((event.url !== '/registration-skills' && event.url !== '/en/registration-skills' ) && (event.url !== '/kr/registration-skills' && event.url !== '/cn/registration-skills' ) ) &&
        // tslint:disable-next-line:max-line-length
        ((event.url !== '/registration-skills-preview' && event.url !== '/en/registration-skills-preview') &&  (event.url !== '/kr/registration-skills-preview' && event.url !== '/cn/registration-skills-preview'))
        ) {
              localStorage.removeItem('skills-info');
        }

        // tslint:disable-next-line:max-line-length
        if ( ((event.url !== '/registration-job-history' && event.url !== '/en/registration-job-history' ) && (event.url !== '/kr/registration-job-history' && event.url !== '/cn/registration-job-history' ) ) &&
        // tslint:disable-next-line:max-line-length
        ((event.url !== '/registration-job-history-preview' && event.url !== '/en/registration-job-history-preview') && (event.url !== '/kr/registration-job-history-preview' && event.url !== '/cn/registration-job-history-preview'))
        ) {
              localStorage.removeItem('job-history');
        }

        // tslint:disable-next-line:max-line-length
        if ( ((event.url !== '/registration-translation-interpretation' && event.url !== '/en/registration-translation-interpretation' ) && (event.url !== '/kr/registration-translation-interpretation' && event.url !== '/cn/registration-translation-interpretation' ) ) &&
        // tslint:disable-next-line:max-line-length
        ((event.url !== '/registration-translation-interpretation-preview' && event.url !== '/en/registration-translation-interpretation-preview') && (event.url !== '/kr/registration-translation-interpretation-preview' && event.url !== '/cn/registration-translation-interpretation-preview') )
        ) {
              localStorage.removeItem('translation-info-form');
        }

        // tslint:disable-next-line:max-line-length
        if ( ((event.url !== '/registration-narrator' && event.url !== '/en/registration-narrator' ) && (event.url !== '/kr/registration-narrator' && event.url !== '/cn/registration-narrator' ) ) &&
        // tslint:disable-next-line:max-line-length
        ((event.url !== '/registration-narrator-preview' && event.url !== '/en/registration-narrator-preview') && (event.url !== '/kr/registration-narrator-preview' && event.url !== '/cn/registration-narrator-preview'))
        ) {
        this.localIndexDBStorage
        .removeItem('staff-narrator-form')
        .subscribe(() => {});
        }
        // tslint:disable-next-line:max-line-length
        if ( ((event.url !== '/self-promotion' && event.url !== '/en/self-promotion' ) && (event.url !== '/kr/self-promotion' && event.url !== '/cn/self-promotion' ) ) &&
        // tslint:disable-next-line:max-line-length
        ((event.url !== '/self-promotion-preview' && event.url !== '/en/self-promotion-preview') && (event.url !== '/kr/self-promotion-preview' && event.url !== '/cn/self-promotion-preview'))
        )
         {
              localStorage.removeItem('staff-self-promotion');
        }

  

      }
    });
  }

  ngOnInIt(){
      this.titleService.setTitle(title);
    //  this.setUpAnalytics();
  }
  setUpAnalytics() {
      debugger;
      alert('ss');  
      this.router.events.pipe(filter(event => event instanceof NavigationEnd))
          .subscribe((event: NavigationEnd) => {
              gtag('config', 'UA-2495607-27',
                  {
                      page_path: event.urlAfterRedirects
                  }
              );
          });
  }
}
 